<template>
  <v-container grid-list-xl fluid>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title>
            <v-text-field
              ref="searchRef"
              class="ml-4"
              append-icon="search"
              label="Search By Card No."
              v-model="search"
              clearable
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>

            <v-btn fab dark small color="amber darken-2" @click="playData()">
              <v-icon dark>play_arrow</v-icon>
            </v-btn>

            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="refreshData()"
              >
                <v-icon>refresh</v-icon>
              </v-btn>
              <span>Refresh</span>
            </v-tooltip>
            <add-button
              v-if="$moduleAccess('add_master_card')"
              @add="openAddDialog"
            ></add-button>
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="downloadExcel()"
              >
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="#ffffff"
                    d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                  />
                </svg>
              </v-btn>
              <span>Download Excel File</span>
            </v-tooltip>
            <!-- <add-button v-if="$moduleAccess('add_master_card')" @add="openAddDialog"></add-button> -->
            <!-- Dialog for Add View Edit -->
            <action-dialog
              :type="dialogType"
              :title="title"
              :dialog="dialogStatus"
              @saveDialog="saveDialog"
              @closeDialog="closeDialog"
              :loading="dialogLoading"
              :disableSave="dialogType == 'view'"
            >
              <v-container grid-list-xs>
                <v-layout justify-center>
                  <v-flex md12>
                    <!-- Insert View Dialog Content BELOW-->
                    <details-container
                      ref="detailsRef"
                      :data="viewData"
                      :contacts="contacts"
                      :devices="devices"
                      :companies="companies"
                      :readonly="dialogType === 'view'"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </action-dialog>

            <delete-dialog
              :title="title"
              :type="deleteType"
              :deleteDialog="deleteDialog"
              @saveDeleteDialog="saveDeleteDialog"
              @closeDeleteDialog="closeDeleteDialog"
              :loading="confirmLoading"
            ></delete-dialog>

            <confirm-dialog
              :confirmDialog="openConfirmDialog"
              @saveConfirmDialog="
                dialogType === 'edit'
                  ? saveEditDialog()
                  : dialogType === 'add'
                  ? saveAddDialog()
                  : ''
              "
              @closeConfirmDialog="closeConfirmDialog"
              :loading="confirmLoading"
            ></confirm-dialog>
          </v-card-title>

          <v-divider></v-divider>

          <v-container
            grid-list-lg
            fluid
            style="padding: 20px 0px 0px 25px"
            class="mt-3"
          >
            <v-layout>
              <v-flex md3 style="padding: 15px;">
                <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="menu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateTo"
                    label="Select Date"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    v-model="dateTo"
                    :max="new Date().toISOString().substr(0, 10)"
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>
          

          <v-divider></v-divider>
          <bottom-scroll @on-bottom="loadMore" :offset="queryParams.offset">
            <v-data-table
              :headers="headers"
              :items="items"
              hide-actions
              disable-initial-sort
            >
              <template slot="headers" slot-scope="props">
                <tr>
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="[
                      'column sortable',
                      header.value === queryParams.order ? 'active' : '',
                      'text-xs-' + header.align,
                    ]"
                  >
                    <span>{{ header.text }}</span>
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <td class="text-xs-center">
                  {{ props.index + 1 }}
                </td>
                <!-- <td class="text-xs-center">{{ props.item.card_no }}</td> -->
                <td class="text-xs-center">
                  {{ props.item.card_no ? props.item.card_no : "--" }}
                </td>
                <td class="text-xs-left text-uppercase no-wrap">
                  {{
                    props.item.company_mastercard_contact_first_name
                      ? props.item.company_mastercard_contact_last_name
                        ? props.item.company_mastercard_contact_first_name +
                          " " +
                          props.item.company_mastercard_contact_last_name
                        : "--"
                      : "--"
                  }}
                </td>
                <!-- <td class="text-xs-center">
                  {{
                    props.item.company_mastercard_contact_no
                      ? props.item.company_mastercard_contact_no
                      : "--"
                  }}
                </td> -->
                <!-- <td class="text-xs-left text-uppercase no-wrap">
                  {{ props.item.company_name ? props.item.company_name : "--" }}
                </td>
                <td class="text-xs-left text-uppercase no-wrap">
                  {{
                    props.item.sub_company_name
                      ? props.item.sub_company_name
                      : "--"
                  }}
                </td> -->
                <!-- <td class="text-xs-left text-uppercase no-wrap">
                  {{
                    props.item.terminal_name ? props.item.terminal_name : "--"
                  }}
                </td> -->
                <!-- <td class="text-xs-left text-uppercase no-wrap">
                  {{
                    props.item.device_serial ? props.item.device_serial : "--"
                  }}
                </td> -->
                <td class="text-xs-left text-uppercase no-wrap">
                  {{
                    props.item.remaining_balance
                      ? $amountInPeso(props.item.remaining_balance)
                      : $amountInPeso(0)
                  }}
                </td>
                <td class="text-xs-left text-uppercase no-wrap">
                  {{ props.item.trans_date ? props.item.trans_date : "--" }}
                </td>
                <td class="text-xs-left text-uppercase no-wrap">
                  {{ props.item.trans_time ? props.item.trans_time : "--" }}
                </td>
                <td class="text-xs-left text-uppercase no-wrap">
                  {{
                    props.item.trans_type
                      ? props.item.project + " - " + props.item.trans_type
                      : "--"
                  }}
                </td>
                <!-- <td class="text-xs-left text-uppercase no-wrap">
                  {{
                    props.item.merchant_assignment
                      ? props.item.merchant_assignment
                      : "--"
                  }}
                </td> -->
                <td class="text-xs-right text-uppercase no-wrap">
                  {{
                    props.item.load_allocation
                      ? $amountInPeso(props.item.load_allocation)
                      : $amountInPeso(0)
                  }}
                </td>
                <td class="text-no-wrap text-xs-center">
                  <view-button @view="openViewDialog(props.item)"></view-button>
                  <edit-button
                    v-if="$moduleAccess('edit_master_card')"
                    @edit="openEditDialog(props.item)"
                  ></edit-button>
                  <delete-button
                    v-if="$moduleAccess('delete_master_card')"
                    @delete="openDeleteDialog(props.item)"
                  ></delete-button>
                </td>
              </template>
            </v-data-table>
          </bottom-scroll>
          <v-divider></v-divider>
          <v-container class="py-0" fluid>
            <v-layout wrap align-center class="pa-5"></v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <v-dialog v-model="dialog" max-width="500" persistent>
        <v-card>
          <v-card-title>
            <span class="font-weight-bold headline">Contact Information</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-container>
            <v-form ref="formNewMasterCard">
              <v-text-field
                v-model="data.first_name"
                label="First Name"
                required
                :rules="[rules.required]"
              ></v-text-field>
              <v-text-field
                v-model="data.last_name"
                label="Last Name"
                required
                :rules="[rules.required]"
              ></v-text-field>
              <v-text-field
                v-model="data.add_contact_no"
                label="Contact Number (must start with 639)"
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-form>
          </v-container>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :loading="loading"
              :disabled="loading"
              color="green darken-1"
              flat="flat"
              @click="saveAddDialogContact()"
              >Save</v-btn
            >
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="red darken-1"
              flat="flat"
              @click="closeDialogContact()"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import DetailsContainer from "@/components/details_container/MasterCardDetailsContainer.vue";
import XLSX from "xlsx";
import moment from "moment";
var now = new Date();

export default {
  components: {
    DetailsContainer,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      response_all: null,
      excel_items: [],
      items: [],
      items1: [],
      companies: [],
      subcompanies: [],
      terminals: [],
      devices: [],
      contacts: [],
      filterCompanies: [],
      filterSubCompanies: [],
      filterTerminals: [],
      scrollItems: [],
      CardNumberList: [],
      perDayBalance: [],
      currentDate: null,
      filterCompany: "",
      filterSubCompany: "",
      filterTerminal: "",
      assignCompany: "",
      assignSubCompany: "",
      assignTerminal: "",
      assignDevice: "",
      assignContact: "",
      openFilter: false,
      openPanel: [true],
      e1: 0,
      title: "Master Card",
      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Card No.",
          align: "center",
          value: "card_no",
          sortable: false,
        },
        {
          text: "Contact Name",
          align: "left",
          value: "name",
          sortable: false,
        },
        // {
        //   text: "Contact Number",
        //   align: "center",
        //   value: "contact_no",
        //   sortable: false,
        // },
        // {
        //   text: "Company",
        //   align: "left",
        //   value: "company",
        //   sortable: false,
        // },
        // {
        //   text: "Subcompany",
        //   align: "left",
        //   value: "sub_company",
        //   sortable: false,
        // },
        // {
        //   text: "Terminal",
        //   align: "left",
        //   value: "terminal",
        //   sortable: false,
        // },
        // {
        //   text: "Device",
        //   align: "left",
        //   value: "device",
        //   sortable: false,
        // },
        {
          text: "Remaining Balance",
          align: "left",
          value: "remaining_Balance",
          sortable: false,
        },
        {
          text: "Last Transaction Date",
          align: "left",
          value: "last_transaction_date",
          sortable: false,
        },
        {
          text: "Last Transaction Time",
          align: "left",
          value: "last_transaction_time",
          sortable: false,
        },
        {
          text: "Last Transaction Type",
          align: "left",
          value: "lasTransaction_type",
          sortable: false,
        },
        // {
        //   text: "Merchant Assignment",
        //   align: "left",
        //   value: "merchant_assignment",
        //   sortable: false,
        // },
        {
          text: "Load Allocation",
          align: "right",
          value: "load_allocation",
          sortable: false,
        },
        {
          text: "Actions",
          align: "center",
          value: "contact_no",
          sortable: false,
        },
      ],
      data: {
        card_no: "",
      },
      preview_data_contact_no: "",
      viewData: {},
      valid: true,
      rules: {
        required: (value) => !!value || "This field is required.",
        counter: (value) => value.length >= 16 || "Must be 16 digits",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      queryParams: {
        search: null,
        limit: 50,
        offset: 0,
        date_to: null,
      },
      excelQueryParams: {
        search: null,
        limit: 0,
        offset: 0,
        date_to: null,
      },
      search: null,
      menu: false,
      deleteDialog: false,
      deleteType: "",
      totalItems: 0,
      dialogLoading: false,
      dialogType: "",
      dialogStatus: false,
      openConfirmDialog: false,
      confirmLoading: false,
      dateFromMenu: false,
      dateToMenu: false,
      date_from: this.$dateFormat(now, "YYYY-MM-DD"),
      date_to: this.$dateFormat(now, "YYYY-MM-DD"),
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 },
        { text: 60, value: 60 },
        { text: 70, value: 70 },
        { text: 80, value: 80 },
        { text: 90, value: 90 },
        { text: 100, value: 100 },
      ],
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      disabledLimit: true,
      loadItems: 50,
      loadMoreData: true,
    };
  },
  created: async function() {},
  computed: {
    dateTo: {
      get() {
        this.queryParams.date_to = this.date_to;
        // this.excelQueryParams.date_to = this.date_to;

        return this.date_to;
      },
      set(value) {
        this.queryParams.date_to = value;
        // this.excelQueryParams.date_to = this.date_to;
        this.date_to = value;
      },
    },
    pageLimit: {
      get() {
        return 50;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      },
    },
  },
  watch: {
    assignContact: async function() {
      if (this.assignContact) {
        await this.setContactPreview();
      }
    },
    // filterCompany: async function() {
    //   if (
    //     this.filterCompany !== null &&
    //     this.filterCompany !== undefined &&
    //     this.filterCompany !== ""
    //   ) {
    //     this.queryParams.offset = 0;
    //     this.queryParams.company_id = this.filterCompany;
    //     // this.getData();
    //   } else if (this.filterCompany === undefined) {
    //     // will proceed here once 'x' button of dropdown is clicked..
    //     this.queryParams.offset = 0;
    //     this.queryParams.company_id = null;
    //     // this.getData();
    //   } else {
    //     // will proceed here once refreshData() is invoked or called..
    //     this.queryParams.offset = 0;
    //     this.queryParams.company_id = null;
    //   }
    // },
    // filterSubCompany: async function() {
    //   if (
    //     this.filterSubCompany !== null &&
    //     this.filterSubCompany !== undefined &&
    //     this.filterSubCompany !== ""
    //   ) {
    //     this.queryParams.offset = 0;
    //     this.queryParams.sub_company_id = this.filterSubCompany;
    //     // this.getData();
    //   } else {
    //     this.queryParams.offset = 0;
    //     this.queryParams.sub_company_id = null;
    //   }
    // },
    // filterTerminal: async function() {
    //   if (
    //     this.filterTerminal !== null &&
    //     this.filterTerminal !== undefined &&
    //     this.filterTerminal !== ""
    //   ) {
    //     this.queryParams.offset = 0;
    //     this.queryParams.terminal_id = this.filterTerminal;
    //     // this.getData();
    //   } else {
    //     this.queryParams.offset = 0;
    //     this.queryParams.terminal_id = null;
    //   }
    // },
  },
  methods: {
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async getData() {
      // Start Loading
      this.$store.dispatch("startLoading");
      this.CardNumberList = [];
      this.perDayBalance = [];
      try {
        // Query Data
        let response = (await Services.getMasterCardsDLTB(this.queryParams)).data;

        // Below is a initialized array response that is accessible to all...
        this.items1 = response.data;
        this.items = [...this.items, ...this.items1];

        // Assign Total number of data///
        this.totalItems = response.count;

        // Assign Number started the data
        this.itemFrom = this.totalItems > 0 ? this.queryParams.offset + 1 : 0;

        // Assign Number end the data
        this.itemTo = this.queryParams.offset + this.queryParams.limit;

        if (this.totalItems <= this.itemTo) {
          this.itemTo = this.totalItems;
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network connection",
          });
        }
      }
      this.$store.dispatch("endLoading");
    },
    refreshData() {
      this.items = [];
      this.$refs.searchRef.reset();
      this.queryParams.search = null;
      this.search = null;
      this.filterCompany = null;
      this.filterSubCompany = null;
      this.filterTerminal = null;
      this.loadMoreData = false;
      this.queryParams.offset = 0;
      this.date_to = this.$dateFormat(now, "YYYY-MM-DD");
      this.getData();
    },
    async loadMore() {
      if (!this.loadMoreData) {
        return;
      }
      this.queryParams.offset = this.items.length;
      if (this.items.length == this.totalItems) {
        this.loadMoreData = false;
        return;
      }

      await this.getData();
    },
    async playData() {
      this.items = [];

      this.queryParams.search = this.search;
      this.queryParams.company_id = this.filterCompany;
      this.queryParams.sub_company_id = this.filterSubCompany;
      this.queryParams.terminal_id = this.filterTerminal;
      this.queryParams.date_to = this.date_to;
      this.loadMoreData = true;

      this.queryParams.offset = 0;

      this.getData();
    },
    async openAddDialog() {
      this.dialogLoading = true;

      this.dialogType = "add";
      this.dialogStatus = true;

      this.e1 = 0;

      this.viewData = {
        id: "",
        company_id: null,
        sub_company_id: null,
        terminal_id: null,
        company_mastercard_contact_id: null,
        card_no: "",
        device_id: null,
        load_allocation: "",
        merchant_assignment: null,
      };

      await this.setCompanies();

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openViewDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "view";
      this.dialogStatus = true;

      this.viewData = await this.setData(data);

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openEditDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "edit";
      this.dialogStatus = true;

      this.e1 = 5;

      await this.setContactEdit();
      await this.setDevicesEdit(data);

      this.viewData = await this.setData(data);

      this.data.id = data.id;

      await this.setCompanies();

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    openDeleteDialog(data) {
      this.deleteDialog = true;
      this.deleteType = "single";
      this.data.id = data.id;
    },
    closeDeleteDialog() {
      this.deleteDialog = false;
    },
    async closeDialog() {
      if (this.dialogLoading === false && this.dialogType === "add") {
        this.$refs.detailsRef.resetForm();
      }

      this.viewData = {};

      this.closeConfirmDialog();
      this.dialogType = "";
      this.dialogStatus = false;
    },
    saveDialog() {
      if (this.dialogType === "add") {
        if (this.$refs.detailsRef.validateForm()) {
          this.openConfirmDialog = true;
        }
      }
      if (this.dialogType === "edit") {
        if (this.$refs.detailsRef.validateForm()) {
          this.openConfirmDialog = true;
        }
      }
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async setData(items) {
      let data = null;

      if (this.dialogType == "view") {
        data = {
          id: items.id,
          master_contact_name: items.company_mastercard_contact_first_name
            ? items.company_mastercard_contact_first_name.toUpperCase() +
              " " +
              items.company_mastercard_contact_last_name.toUpperCase()
            : "",
          card_no: items.card_no ? items.card_no : "",
          contact_no: items.company_mastercard_contact_no
            ? items.company_mastercard_contact_no
            : "",
          company_mastercard_contact_id: items.company_mastercard_contact_id
            ? items.company_mastercard_contact_id
            : "",
          load_allocation: items.load_allocation ? items.load_allocation : "",
        };
      }

      if (this.dialogType == "edit") {
        data = {
          id: items.id,
          company_mastercard_contact_id: items.company_mastercard_contact_id
            ? items.company_mastercard_contact_id
            : null,
          card_no: items.card_no ? items.card_no : "",
          load_allocation: items.load_allocation ? items.load_allocation : "",
        };
      }

      return data;
    },

    async setCompanies() {
      this.companies = [];
      const items = (
        await Services.getCompanies({
          project_id: this.$store.state.employee.project_id,
        })
      ).data;

      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };
        this.companies.push(data);
      }
    },
    async setSubCompanies() {
      this.subcompanies = [];
      const items = (
        await Services.getSubCompanies({
          project_id: this.$store.state.employee.project_id,
          company_id: this.assignCompany,
        })
      ).data;

      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };
        this.subcompanies.push(data);
      }
    },
    async setTerminals() {
      this.terminals = [];
      const items = (
        await Services.getTerminals({
          company_id: this.assignCompany,
          sub_company_id: this.assignSubCompany,
        })
      ).data;

      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };
        this.terminals.push(data);
      }
    },
    async setDevices() {
      this.devices = [];
      const items = (
        await Services.getDevices({
          project_id: this.$store.state.project.id,
          company_id: this.assignCompany,
          sub_company_id: this.assignSubCompany,
          terminal_id: this.assignTerminal,
        })
      ).data;

      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].device_serial.toUpperCase(),
          value: el[i].id,
        };
        this.devices.push(data);
      }
    },
    async setContact() {
      this.contacts = [];
      const items = (
        await Services.getMasterCardContacts({
          sub_company_id: this.assignSubCompany,
        })
      ).data;

      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text:
            el[i].first_name.toUpperCase() +
            " " +
            el[i].last_name.toUpperCase(),
          value: el[i].id,
        };
        this.contacts.push(data);
      }
    },
    async setContactEdit() {
      this.contacts = [];
      const items = (await Services.getMasterCardContacts({})).data;

      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text:
            el[i].first_name.toUpperCase() +
            " " +
            el[i].last_name.toUpperCase(),
          value: el[i].id,
        };
        this.contacts.push(data);
      }
    },
    async setDevicesEdit(data) {
      this.devices.length = 0;
      const items = (
        await Services.getDevices({
          project_id: this.$store.state.employee.project_id,
          company_id: data.company_id,
          sub_company_id: data.sub_company_id,
          terminal_id: data.terminal_id,
        })
      ).data;

      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].device_serial.toUpperCase(),
          value: el[i].id,
        };
        this.devices.push(data);
      }
    },
    async setContactPreview() {
      this.preview_data = {};
      const items = (await Services.getMasterCardContact(this.assignContact))
        .data;

      this.preview_data_contact_no = items.data.contact_no;
    },
    async eTwo() {
      if (this.$refs.formCompany.validate()) {
        this.e1 = 2;
        await this.setSubCompanies();
      }
    },
    async eThree() {
      if (this.$refs.formSubCompany.validate()) {
        this.e1 = 3;
        await this.setTerminals();
      }
    },
    async eFour() {
      if (this.$refs.formTerminal.validate()) {
        this.e1 = 4;
        await this.setDevices();
      }
    },
    async eFive() {
      this.e1 = 5;
      await this.setContact();
    },
    async openFilterExpansion() {
      this.openFilter = !this.openFilter;
      if (this.openFilter) {
        await this.setFilterItems();
      }
    },
    async setFilterItems() {
      this.$store.dispatch("startLoading");
      try {
        let filters = await Services.getMasterCardFilters();
        this.filterCompanies = [];
        this.filterSubCompanies = [];
        this.filterTerminals = [];

        await filters.data.company_filter.map((item) => {
          let data = {
            text: item.name.toUpperCase(),
            value: item.name,
          };

          this.filterCompanies.push(data);
        });

        await filters.data.sub_company_filter.map((item) => {
          let data = {
            text: item.name.toUpperCase(),
            value: item.name,
          };

          this.filterSubCompanies.push(data);
        });

        await filters.data.terminal_filter.map((item) => {
          let data = {
            text: item.name.toUpperCase(),
            value: item.name,
          };

          this.filterTerminals.push(data);
        });
      } catch (error) {
        this.$infoBar({
          type: "error",
          text: "No network connection",
        });
      }
      this.$store.dispatch("endLoading");
    },
    closeDialogContact() {
      this.$refs.formNewMasterCard.reset();
      this.dialog = false;
    },
    async saveAddDialog() {
      this.confirmLoading = true;

      const data = this.$refs.detailsRef.computedData;

      const body = {
        card_no: data.card_no,
        company_mastercard_contact_id: data.company_mastercard_contact_id,
        load_allocation: data.load_allocation,
      };

      try {
        const response = await Services.addMasterCard(body);

        if (
          response.status === 201 ||
          response.status === 204 ||
          response.status === 200
        ) {
          this.closeDialog();
          await this.refreshData();
          this.$infoBar({
            type: "success",
            text: "Master Card has been added!",
          });
        } else {
          this.closeConfirmDialog();
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        this.closeConfirmDialog();
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        } else {
          if (error.response.status === 404) {
            this.$infoBar({
              type: "error",
              text: this.titleCase(error.response.data.message) + "!",
            });
          } else {
            this.$infoBar({
              type: "error",
              text: this.titleCase(error.response.data.message) + "!",
            });
          }
        }
      }
      this.confirmLoading = await false;
    },
    async saveAddDialogContact() {
      if (this.$refs.formNewMasterCard.validate()) {
        this.loading = true;
        const body = {
          first_name: this.data.first_name,
          last_name: this.data.last_name,
          contact_no: this.data.add_contact_no,
          company_id: this.assignCompany,
          sub_company_id: this.assignSubCompany,
        };
        try {
          const response = await Services.addMasterCardContact(body);
          if (
            response.status === 201 ||
            response.status === 204 ||
            response.status === 200
          ) {
            await this.setContact();
            this.closeDialogContact();
            this.$infoBar({
              type: "success",
              text: "Master Card Contact Number has been added!",
            });
          } else {
            this.dialog = false;
            this.$infoBar({
              type: "error",
              text: "Server Error!",
            });
          }
        } catch (error) {
          if (!error.response) {
            this.dialog = false;
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          } else {
            if (error.response.status === 404) {
              this.dialog = false;
              this.$infoBar({
                type: "error",
                text: this.titleCase(error.response.data.message) + "!",
              });
            } else {
              this.dialog = false;
              this.$infoBar({
                type: "error",
                text: this.titleCase(error.response.data.message) + "!",
              });
            }
          }
        }
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },
    async saveEditDialog() {
      this.confirmLoading = true;

      const data = this.$refs.detailsRef.computedData;

      const body = {
        id: data.id,
        card_no: data.card_no,
        company_mastercard_contact_id: data.company_mastercard_contact_id,
        load_allocation: data.load_allocation,
      };

      try {
        const response = await Services.editMasterCard(body.id, body);

        if (
          response.status === 201 ||
          response.status === 204 ||
          response.status === 200
        ) {
          this.closeDialog();
          await this.refreshData();
          this.$infoBar({
            type: "success",
            text: "Master Card has been Edited!",
          });
        } else {
          this.closeConfirmDialog();
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        this.closeConfirmDialog();
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        } else {
          if (error.response.status === 404) {
            this.$infoBar({
              type: "error",
              text: this.titleCase(error.response.data.message) + "!",
            });
          } else {
            this.$infoBar({
              type: "error",
              text: this.titleCase(error.response.data.message) + "!",
            });
          }
        }
      }
      this.confirmLoading = await false;
    },
    async saveDeleteDialog() {
      this.confirmLoading = true;

      try {
        const response = await Services.deleteMasterCard(this.data.id);
        if (response.status === 200 || response.status === 201) {
          this.closeDeleteDialog();
          await this.playData();
          this.$infoBar({
            type: "success",
            text: "Master Card has been deleted!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = false;
    },
    titleCase(str) {
      let splitStr = str.toLowerCase().split(" ");
      for (let i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      return splitStr.join(" ");
    },
    closeConfirmDialog() {
      this.openConfirmDialog = false;
    },
    async downloadExcel() {
      try {
        this.$store.dispatch("startLoading");
      this.excel_items = [];
      this.excelQueryParams.date_to = this.date_to;
      let response = (await Services.getMasterCardsDLTB(this.excelQueryParams))
        .data;

      this.excel_items = response.data;

      let dataToDownload = [];
      let header = [];

      for (let i = 0; i < this.headers.length; i++) {
        header.push(this.headers[i].text);
      }
      header.shift();
      header.pop();
      dataToDownload.push(header);
      // console.log("TEST LENGHT::", this.excel_items.length);
      for (let e = 0; e < this.excel_items.length; e++) {
        let theItem = [];

        theItem.push(
          this.excel_items[e].card_no ? this.excel_items[e].card_no : 0
        );

        theItem.push(
          this.excel_items[e].company_mastercard_contact_first_name
            ? this.excel_items[e].company_mastercard_contact_last_name
              ? this.excel_items[e].company_mastercard_contact_first_name.toUpperCase() +
                " " +
                this.excel_items[e].company_mastercard_contact_last_name.toUpperCase()
              : "--"
            : "--"
        );

        // theItem.push(
        //   this.excel_items[e].company_mastercard_contact_no
        //     ? this.excel_items[e].company_mastercard_contact_no
        //     : "--"
        // );
        // theItem.push(
        //   this.excel_items[e].company_name
        //     ? this.excel_items[e].company_name.toUpperCase()
        //     : "--"
        // );
        // theItem.push(
        //   this.excel_items[e].sub_company_name
        //     ? this.excel_items[e].sub_company_name.toUpperCase()
        //     : "--"
        // );
        // theItem.push(
        //   this.excel_items[e].terminal_name
        //     ? this.excel_items[e].terminal_name.toUpperCase()
        //     : "--"
        // );
        // theItem.push(
        //   this.excel_items[e].device_serial
        //     ? this.excel_items[e].device_serial
        //     : "--"
        // );
        theItem.push(
          this.excel_items[e].remaining_balance
            ? this.$amountInPeso(this.excel_items[e].remaining_balance) 
            : this.$amountInPeso(0) 
        );
        theItem.push(
          this.excel_items[e].trans_date ? this.excel_items[e].trans_date : "--"
        );
        theItem.push(
          this.excel_items[e].trans_time ? this.excel_items[e].trans_time : "--"
        );
        theItem.push(
          this.excel_items[e].trans_type ? this.excel_items[e].project.toUpperCase() + " - " + this.excel_items[e].trans_type.toUpperCase() : "--"
        );
        // theItem.push(
        //   this.excel_items[e].merchant_assignment ? this.excel_items[e].merchant_assignment : "--"
        // );
        theItem.push(
          this.excel_items[e].load_allocation
            ? this.$amountInPeso(this.excel_items[e].load_allocation) 
            : this.$amountInPeso(0)
        );
        // 

        dataToDownload.push(theItem);
      }

      this.$store.dispatch("endLoading");

      // don't delete any codes after this comment got it?!

      var wscols = [
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
      ];

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      // var wsname = "SheetJS";

      var fmt = "#,##0.00";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }
      // wb.SheetNames.push(wsname);
      // wb.Sheets[wsname] = ws;
      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      // ws["!protect"] = {
      //   password: "Journeytech@1",
      //   formatRows: false,
      //   formatColumns: false,
      //   objects: true,
      //   scenarios: true
      // };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
      } catch (error) {
        console.log(error)
      }
    },
  },
};
</script>

<style scoped></style>
